export default {
    listagem: {
        titulo_pagina: 'Configuración de protocolos genéricos',
        novo: 'Crear Nueva Configuración',
        table: {
            empty: 'No se encontró ninguna configuración',
            nome: 'Nombre',
            metodo: 'Método',
            ordem_url: 'Url para procesar el pedido',
            resultado_url: 'Url para procesar el Resultado',
            busca_resultado_url: 'Endpoint para el resultado',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nueva Configuración',
            editar: 'Editar Configuración'
        },
        fields: {
            nome: {
                label: 'Nombre',
                description: 'Nombre de configuración'
            },
            metodo: {
                label: 'Método',
                description: 'Método ejecutado por Protocolo'
            },
            ordem_url: {
                label: 'Url para procesar el pedido',
                description: 'Url donde se extraerá el pedido y la etiqueta'
            },
            resultado_url: {
                label: 'Url para procesar el resultado',
                description: 'Url donde se extraerá el resultado'
            },
            busca_resultado_url: {
                label: 'Endpoint para resultados de búsqueda',
                description: 'Se completará, si es diferente de la URL predeterminada de la integración.'
            },
            tipo_conteudo: {
                label: 'Content-type',
                description: 'Llenar para content-type personalizado'
            },
            botao_salvar : 'Guardar Configuración'
        },
        create: {
            success: '¡Configuración creada con éxito!',
            error: '¡Error al crear la configuración!'
        },
        update: {
            success: '¡Configuración editada con éxito!',
            error: '¡Error al editar la configuración!'
        }
    }
}
